import React, { FC, useState } from 'react'
import { Grid, Typography } from '@material-ui/core'
import { dataTableActions, getStyles } from 'isotope-client'
import withStyles from '@material-ui/core/styles/withStyles'
import { FormattedMessage } from 'react-intl'
import AddSortieForm from './components/AddSortieForm'
import SortieHistory from './components/SortieHistory'
import { PreviousSortieFormValues, SortieForm } from './services/sortie.types'
import { addSortie } from './services/sortie.api'
import { ADD_SORTIE_FORM, SORTIES_DATATABLE } from './services/sortie.consts'
import { useSnackbar } from '../../../components/layout/snackbar/SnackbarContext'
import { compose } from 'redux'
import { connect } from 'react-redux'
import DialogProvider from '../../../components/layout/contextProvider/DialogProvider'

const styles = () => getStyles({
	root: {
		minHeight: 'calc(100vh - 92px)',
		padding: '14px 24px',
		scrollbarWidth: 'none' as 'none',
		msOverflowStyle: 'none' as 'none',
		'&::-webkit-scrollbar': {
			width: 0
		}
	},
	header: {
		alignItems: 'center',
		height: 40,
		columnGap: 64
	},
	bodyGap: {
		gap: 12
	},
	pageTitle: {
		fontSize: 24
	},
	sectionTitle: {
		fontSize: 18
	}
})

type SortieProps = {
	refreshTable: () => void
	classes: ClassNameMap
}

const SortiePage: FC<SortieProps> = ({ refreshTable, classes }) => {
	const [previousFormValues, setPreviousFormValues] = useState<PreviousSortieFormValues | undefined>(undefined)
	const { snackSuccess, snackError } = useSnackbar()

	const submitAdd = (values: SortieForm) => {
		return addSortie(values)
			.then(() => {
				refreshTable()
				snackSuccess({ id: 'sorties.form.success' })
				setPreviousFormValues({
					idCulture: values.idCulture,
					idDebouche: values.idDebouche,
					typeConditionnement: values.typeConditionnement
				})
			})
			.catch(() => snackError({ id: 'sorties.form.error' }))
	}

	return <DialogProvider>
		<Grid container direction="column" className={classes.root}>
			<Grid item className={classes.header}>
				<Typography variant="h1" className={classes.pageTitle}>
					<FormattedMessage id="sorties.title" />
				</Typography>
			</Grid>
			<Grid item container direction="column" className={classes.bodyGap}>
				<Grid item>
					<Typography variant="h1" className={classes.sectionTitle}>
						<FormattedMessage id="sorties.sections.add" />
					</Typography>
				</Grid>
				<Grid item>
					<AddSortieForm
						form={ADD_SORTIE_FORM}
						onSubmit={submitAdd}
						previousFormValues={previousFormValues}
					/>
				</Grid>
				<Grid item container direction="row" className={classes.bodyGap}>
					<SortieHistory />
				</Grid>
			</Grid>
		</Grid>
	</DialogProvider>
}

const actions = {
	refreshTable: () => dataTableActions.refresh(SORTIES_DATATABLE)
}

export default compose<FC>(
	connect(undefined, actions),
	withStyles(styles)
)(SortiePage)